import { useMutation } from '@tanstack/react-query';
import { publicPost } from '@/lib/api/publicClient';
import { publicReviews } from '@/lib/api/endpoints';
import type { ReviewPlatformId } from './useReviewLanding';

export interface PlatformClickInput {
  platform: ReviewPlatformId;
}

/**
 * Records a platform tap made *before* the customer has picked a rating.
 *
 * The endpoint writes a rating-0 placeholder response and leaves the ask row
 * unclaimed, so the request still reads as OPEN and a later submit fills the
 * placeholder in — tapping through to Google first and rating afterwards is a
 * supported journey, not a lockout. Once a response is committed the endpoint
 * 409s, so the landing screen navigates without calling this hook in that case.
 *
 * A tap made *with* a pending rating goes to `useSubmitReview` instead: rating
 * and platform land in one transaction. The caller performs the redirect.
 */
export function usePlatformClick(token: string) {
  return useMutation({
    mutationFn: (input: PlatformClickInput) =>
      publicPost<{ ok: boolean }, PlatformClickInput>(publicReviews.clickPlatform(token), input),
  });
}
